import {
  BaseResource,
  paginatedListSerializer,
  ResourceAction,
  UuidResourceParam,
} from "@megarax/rest-resource";
import { Serializers } from "@megarax/serializers";
import { permissions } from "../permissions";
import { NewRoleInput, UpdateRoleInput } from "./commands";
import { RoleDto, RoleListFilters, RoleSimple } from "./queries";

export type {
  NewRoleInput,
  UpdateRoleInput,
  RoleDto,
  RoleListFilters,
  RoleSimple,
};

const list = ResourceAction({
  name: "list",
  method: "get",
  path: "",
  querySerializer: Serializers.object<RoleListFilters>({
    searchText: Serializers.string.optional(),
    limit: Serializers.integer.optional(),
    offset: Serializers.integer.optional(),
  }),
  responseSerializer: paginatedListSerializer(
    Serializers.object<RoleSimple>({
      name: Serializers.string,
      uuid: Serializers.uuid(),
    }),
  ),
});

export const roleResource = BaseResource(["iam", "roles"], {
  create: ResourceAction({
    name: "create",
    method: "post",
    path: "",
    requestBodySerializer: Serializers.object<NewRoleInput>({
      uuid: Serializers.uuid(),
      name: Serializers.string,
      permissions: Serializers.array(Serializers.stringOneOf(...permissions)),
    }),
  }),
  list,
  byUuid: UuidResourceParam("roleUuid", {
    retrieve: ResourceAction({
      name: "retrieve",
      method: "get",
      path: "",
      responseSerializer: Serializers.object<RoleDto>({
        name: Serializers.string,
        uuid: Serializers.uuid(),
        permissions: Serializers.array(Serializers.string),
      }),
    }),
    update: ResourceAction({
      name: "update",
      method: "put",
      path: "",
      requestBodySerializer: Serializers.object<UpdateRoleInput>({
        name: Serializers.string,
        permissions: Serializers.array(Serializers.stringOneOf(...permissions)),
      }),
    }),
  }),
});
